exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---27DkK {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"component": "component---27DkK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/formatters/assigned-courses-formatter/index.scss
// module id = 1160
// module chunks = 3